import { render, staticRenderFns } from "./AscBaseSelector.vue?vue&type=template&id=4a9d6a9e&scoped=true&"
import script from "./AscBaseSelector.vue?vue&type=script&lang=js&"
export * from "./AscBaseSelector.vue?vue&type=script&lang=js&"
import style0 from "./AscBaseSelector.vue?vue&type=style&index=0&id=4a9d6a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d6a9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
